import apiRoutes from "startups/apiRoutes";
import { createActionFetcher } from "shared/redux-store/defaults";

export const fetchOrderGroupsOverview = createActionFetcher(
  "ORDER_GROUPS_OVERVIEW",
  [apiRoutes.orderGroupsOverviewPath()],
);

export const fetchOrderGroupsOverviewAll = createActionFetcher(
  "ORDER_GROUPS_OVERVIEW",
  [apiRoutes.orderGroupsOverviewAllPath()],
);
